module.exports = __webpack_public_path__ + "img/cancle.4ea978e2.svg";